// import Head from 'next/head';
import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,

} from '@chakra-ui/react';
import Avnish_Kumar_Resume from '../Resume/Avnish_Kumar_Resume.pdf'
export default function CallToActionWithAnnotation() {
  return (
    <>
       <Container maxW={'3xl'}>
        <Stack
          as={Box}
          textAlign={'center'}
          spacing={{ base: 2, md: 2}}
          py={{ base: 3, md: 5 }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '4xl', md: '6xl' }}
           color={'#EEE'}>
           I am Avnish Kumar  <br />
            <Text as={'span'} color={'#DC143C'}>
           MERN Developer
            </Text>
          </Heading>
          <Text color={'#EEE'} fontSize='md'>
          Experienced MERN developer adept at building
            robust web applications proficient in MongoDB,
            Express.js, React.js, and Node.js. Skilled in frontend
            design, backend implementation and deployment
            Strong problem-solving abilities, collaborative
            mindset and a passion for delivering high-quality
            code.
          </Text>
          <Stack
            direction={'column'}
            spacing={3}
            align={'center'}
            alignSelf={'center'}
            position={'relative'}>
                <a  href={Avnish_Kumar_Resume} download={'Avnish_Kumar_Resume'}>
            
              
            <Button
              colorScheme={'black'}
              bg={'#000'}
              rounded={'5'}
              px={5}

           
                bgColor='#DC143C'
             onClick={()=>{window.open("https://drive.google.com/file/d/17EazqHpb5BhbDUPezOZv2RYWJUV5zHzj/view?usp=sharing","_blank")}}>
              Download CV
            </Button>
            </a>
            <Box>
              
            </Box>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}
